export const iconFontAwesomeMapsJetFighter = (
	<i className="fa-solid fa-jet-fighter"></i>
);
